import React from 'react'
import Header from './Header'
import { Link } from 'react-router-dom'

function Services() {
  return (
    <div>
      <>
        {/*[if lt IE 7]>      <html class="no-js lt-ie9 lt-ie8 lt-ie7" lang=""> <![endif]*/}
        {/*[if IE 7]>         <html class="no-js lt-ie9 lt-ie8" lang=""> <![endif]*/}
        {/*[if IE 8]>         <html class="no-js lt-ie9" lang=""> <![endif]*/}
        {/*[if gt IE 8]><!*/}
        {/*<![endif]*/}
        {/* Mirrored from html.dynamiclayers.net/te/logisko/services-logistic.html by HTTrack Website Copier/3.x [XR&CO'2014], Thu, 05 Dec 2024 18:04:19 GMT */}
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="description"
          content="Safe and Reliable Transportation  Transportation and Logistics "
        />
        <meta name="author" content="ThemeEaster" />
        <title>
          Safe and Reliable Transportation | Transportation and Logistics Company
        </title>
        <link rel="shortcut icon" type="image/x-icon" href="images/logo.png" />
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\n\n.containerr {\n    width: 90%;\n    margin: 0 auto;\n    padding-top: 50px;\n}\n\n.main-heading {\n    font-size: 2.5rem;\n    font-weight: bold;\n    color: red;\n    text-align: left;\n    margin-bottom: 20px;\n}\n\n.intro-text {\n    font-size: 1.2rem;\n    margin-bottom: 40px;\n    color: #555;\n}\n\n.cards-container {\n    display: flex;\n    justify-content: space-between;\n    gap: 20px;\n    flex-wrap: wrap;\n}\n\n.card {\n    background-color: white;\n    padding: 20px;\n    width: 30%;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    text-align: center;\n}\n\n.card-heading {\n    font-size: 1.5rem;\n    font-weight: bold;\n    color: red;\n    margin-bottom: 15px;\n}\n\n.card-text {\n    font-size: 1rem;\n    color: #555;\n}\n\n@media (max-width: 768px) {\n    .cards-container {\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .card {\n        width: 90%;\n        margin-bottom: 20px;\n    }\n}\n\n"
          }}
        />
        {/*[if lt IE 8]>
  <p class="browserupgrade">You are using an <strong>outdated</strong> browser. Please <a href="http://browsehappy.com/">upgrade your browser</a> to improve your experience.</p>
    <![endif]*/}
        <Header />
        <div id="popup-search-box">
          <div className="box-inner-wrap d-flex align-items-center">
            <form id="form" action="#" method="get" role="search">
              <input
                id="popup-search"
                type="text"
                name="s"
                placeholder="Type keywords here..."
              />
              <button id="popup-search-button" type="submit" name="submit">
                <i className="fa-sharp fa-light fa-magnifying-glass" />
              </button>
            </form>
            <div className="search-close">
              <i className="fa-regular fa-xmark" />
            </div>
          </div>
        </div>
        {/*/.popupsearch-box*/}
        <div id="searchbox-overlay" />
        <section className="page-header">
          <div className="container">
            <div className="page-header-info">
              <h4>Your Load Our Commitment</h4>
              <h2>
                Trucking & Freight Services
              </h2>
              <p>
                Full truckload (FTL), enclosed trailer, and expedited freight services. Partner with a trucking <br /> company that prioritizes your cargo’s safety and timely delivery.
              </p>
            </div>
          </div>
        </section>
        {/*page-header*/}
        <section className="about-section padding">
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="about-img-wrap mt-50">
                  <img
                    className="wow fade-in-left"
                    data-wow-delay="100ms"
                    src="images/content-bg-1.jpg"
                    alt="img"
                  />
                  <img
                    className="wow fade-in-bottom"
                    data-wow-delay="300ms"
                    src="images/post-2.jpg"
                    alt="img"
                  />
                </div>
              </div>
              <div className="col-lg-7">
                <div className="section-heading mb-40">
                  {/* <h3 className="sub-heading is-border border-anim" /> */}
                  <h2
                    className="text-anim"
                    data-effect="fade-in-right"
                    data-split="char"
                    data-delay="0.3"
                    data-duration={1}
                  >
                    {" "}
                    Full Truckload (FTL) Shipping{" "}
                  </h2>
                  <p
                    className="text-anim"
                    data-effect="fade-in-bottom"
                    data-ease="power4.out"
                  >
                    At Safe and Reliable Transportation, our Full Truckload (FTL)
                    service is designed for businesses that demand exclusivity,
                    speed, and maximum security for their cargo. When you book an
                    FTL shipment, your goods occupy the entire trailer, eliminating
                    shared space with other shipments and minimizing handling risks.
                    Ideal for large-volume orders, high-value merchandise, or
                    time-sensitive deliveries, our FTL solutions leverage
                    dedicated routes and priority scheduling to ensure your
                    freight arrives faster and intact. Equipped with modern,
                    temperature-controlled trailers  and managed by
                    drivers trained in advanced cargo securement, we guarantee end-to-end
                    visibility via real-time GPS tracking and proactive communication.
                    Whether you’re shipping manufacturing equipment, retail inventory,
                    or bulk materials, trust us to deliver the efficiency and peace of
                    mind only a dedicated truckload can provide.
                  </p>
                </div>
                <div className="btn-group wow fade-in-bottom" data-wow-delay="300ms">
                  <a href='tel:"3017097924"'>  <div className="call-info">
                    <i className="fa-solid fa-phone" />
                    <h3>
                      Have Any Questions?{" "}
                      <span>(301) 709-7924</span>
                    </h3>
                  </div></a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*/.about-section*/}
        <section className="about-section padding">
          <div className="container">
            <div className="row">
              <div className="col-lg-7">
                <div className="section-heading mb-40">
                  <h3 className="sub-heading is-border border-anim">
                    Urgent Deadlines?
                    <span className="sh-underline">
                      <img className="sh-truck" src="images/truck.svg" alt="truck" />
                    </span>
                  </h3>
                  <h2
                    className="text-anim"
                    data-effect="fade-in-left"
                    data-split="char"
                    data-delay="0.3"
                    data-duration={1}
                  >
                    {" "}
                    Expedited Shipping
                  </h2>
                  <p
                    className="text-anim"
                    data-effect="fade-in-bottom"
                    data-ease="power4.out"
                  >
                    When time is critical, Safe and Reliable Transportation’s Expedited Services
                    rise to the challenge, delivering your freight with the urgency it demands.
                    Designed for time-sensitive shipments that can’t afford delays, we prioritize
                    your cargo with direct routes, dedicated drivers, and 24/7 dispatch coordination
                    to bypass logistical bottlenecks. Whether it’s a last-minute order, emergency
                    replacement parts, or perishable goods, our expedited solutions combine speed
                    with unwavering reliability. Leveraging real-time GPS tracking and predictive analytics,
                    we proactively adjust to traffic, weather, or unforeseen disruptions, ensuring your
                    deadlines are met—guaranteed. Backed by a fleet of agile, well-maintained trucks and
                    seasoned drivers trained in rapid-response protocols, we turn tight timelines into
                    opportunities to prove why businesses trust us with their most urgent freight needs.
                    Fast doesn’t mean fragile; we maintain strict safety standards, secure cargo handling,
                    and constant communication, so you’re never left in the dark. When every minute counts, count on us to deliver.
                  </p>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="about-img-wrap mt-50">
                  <img
                    className="wow fade-in-right"
                    data-wow-delay="100ms"
                    src="images/content-bg-2.jpg"
                    alt="img"
                  />
                  <img
                    className="wow fade-in-bottom"
                    data-wow-delay="300ms"
                    src="images/post-3.jpg"
                    alt="img"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="about-section padding">
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="about-img-wrap mt-50">
                  <img
                    className="wow fade-in-left"
                    data-wow-delay="100ms"
                    src="images/content-bg-8.jpg"
                    alt="img"
                  />
                  <img
                    className="wow fade-in-bottom"
                    data-wow-delay="300ms"
                    src="images/post-5.jpg"
                    alt="img"
                  />
                </div>
              </div>
              <div className="col-lg-7">
                <div className="section-heading mb-40">
                  <h3 className="sub-heading is-border border-anim">
                    Customized Logistics
                    <span className="sh-underline">
                      <img className="sh-truck" src="images/truck.svg" alt="truck" />
                    </span>
                  </h3>
                  <h2
                    className="text-anim"
                    data-effect="fade-in-right"
                    data-split="char"
                    data-delay="0.3"
                    data-duration={1}
                  >
                    Dedicated Fleet Solutions:
                  </h2>
                  <p
                    className="text-anim"
                    data-effect="fade-in-bottom"
                    data-ease="power4.out"
                  >
                    For businesses requiring unmatched consistency and control,
                    Safe and Reliable Transportation’s*Dedicated Fleet Solutions
                    offer a customized logistics partnership tailored to your unique
                    operational needs. With a fleet of trucks and drivers reserved
                    exclusively for your shipments, you gain the flexibility to design
                    schedules, routes, and delivery protocols that align perfectly with
                    your business rhythm—whether you’re managing daily distribution, seasonal
                    surges, or specialized cargo demands. Our dedicated teams become an extension
                    of your operation, equipped with advanced telematics for real-time visibility,
                    proactive maintenance to minimize downtime, and experienced drivers trained in
                    your industry’s specific requirements. From retail distribution and manufacturing
                    parts to temperature-sensitive goods, we ensure seamless coordination, reduced
                    transit variability, and enhanced supply chain efficiency. By eliminating the
                    uncertainties of shared freight, we empower you to optimize inventory management,
                    meet customer expectations, and scale confidently. Trust us to deliver not just your
                    goods, but a competitive edge built on reliability, scalability, and a partnership that grows with you.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>


        <footer className="footer-section">
          <div className="map-pattern" />
          <div className="footer-wrapper">
            <div className="container">
              <div className="row gy-lg-0 gy-4">
                <div className="col-lg-3 col-md-6">
                  <div className="footer-widget">
                    <Link to="/" className="footer-logo">
                      <img src="images/logo.png" alt="logo" />
                    </Link>
                    <p>
                      Safe and Reliable Transportation specializes in efficient
                      transport warehousing and distribution of goods.
                    </p>
                    <ul className="social-share">
                      <li>
                        <a href="https://www.facebook.com/profile.php?id=61575268596055">
                          <i className="fa-brands fa-facebook-f" />
                        </a>
                      </li>
                    ®
                  
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="footer-widget widget-links">
                    <div className="widget-title">
                      <h3>Company</h3>
                    </div>
                    <ul className="footer-links">
                      <li>
                        <Link to="/aboutus">About Us</Link>
                      </li>
                      <li>
                        <Link to="/services">Our Services</Link>
                      </li>
                      <li>
                        <Link to="/testimonials">Testimonials</Link>
                      </li>
                      <li>
                        <Link to="/contact">Contact</Link>
                      </li>
                      <li>
                        <a href="https://apply.srtranspor.com/login/driver">Driver Login</a>
                      </li>
                      <li>
                        <a href="https://apply.srtranspor.com/login/company">Customer Login</a>
                      </li>
                      <li>
                        <Link to="/resources">Resources</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="footer-widget">
                    <div className="widget-title">
                      <h3>Get In Touch</h3>
                    </div>
                    <ul className="footer-contact-info">
                      <li>
                        <p>
                          <span>Address:</span>9528 Baltimore, Ave
                          Laurel, MD 20723
                        </p>
                      </li>
                      <li>
                        <p>
                          <span>Mail Us:</span>humanresource@srtranspor.com
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="footer-widget">
                    <div className="widget-title">
                      <h3>Newslatter Signup</h3>
                    </div>
                    <form action="#" className="subscribe-form" noValidate="true">
                      <div className="mc-fields">
                        <input
                          className="form-control"
                          type="email"
                          name="EMAIL"
                          placeholder="Your Email"
                          required=""
                        />
                        <input
                          type="hidden"
                          name="action"
                          defaultValue="mailchimpsubscribe"
                        />
                        <button className="submit">
                          <i className="fa-regular fa-arrow-right-long" />
                        </button>
                      </div>
                      <div className="clearfix" />
                      <div id="subscribe-result">
                        <div className="subscription-success" />
                        <div className="subscription-error" />
                      </div>
                    </form>
                    <p className="mt-20">
                      Subscribe us and get all the benifits from today.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="running-truck">
              <div className="truck" />
              <div className="truck-2" />
              <div className="truck-3" />
            </div>
          </div>
          <div className="copyright-area">
            <span id="currentYear"> </span> © Safe and Reliable Transportation ,
            All Rights Reserved.
          </div>
        </footer>
        {/*/.footer-section*/}
        <div id="scrollup">
          <button id="scroll-top" className="scroll-to-top">
            <i className="fa-regular fa-arrow-up" />
          </button>
        </div>
        {/*/.scrollup*/}
        {/* Mirrored from html.dynamiclayers.net/te/logisko/services-logistic.html by HTTrack Website Copier/3.x [XR&CO'2014], Thu, 05 Dec 2024 18:04:20 GMT */}
      </>

    </div>
  )
}

export default Services